import React from "react";
import styled from "styled-components";

import bgSrcMobile from "../../nmd2025/assets/bg2025_mobile@2x.jpg";
import bgSrcDesktop from "../../nmd2025/assets/bg2025@2x.jpg";

import { Header } from "../../nmd2025/coming-soon/Header/Header";
import { Main } from "../../nmd2025/coming-soon/Main/Main";
import { Footer } from "../../nmd2025/coming-soon/Footer/Footer";

const HomeWrapper = styled.div`
  flex-grow: 1;
  position: relative;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;

  @media (max-width: 1023px) {
    background-image: url(${bgSrcMobile});
  }

  @media (min-width: 1024px) {
    background-image: url(${bgSrcDesktop});
  }
`;

const ComingSoon = () => {
  return (
    <>
      <HomeWrapper>
        <Header />
        <Main />
      </HomeWrapper>
      <Footer />
    </>
  );
};

export default ComingSoon;
